import DynamicElementForm from "components/DynamicElements/DynamicElementForm"
import React, { useContext, useEffect } from "react"
import AuthContext from "context/auth/authContext"
import DynamicElementList from "components/DynamicElements/DynamicElementList"
import HowToAddDynamicElementsModal from "components/DynamicElements/HowToAddDynamicElementsModal"
import { Box, Button } from "@mui/material"
import { Typography } from "@mui/material"
import i18n from "i18n"
import { greyButtonStyle } from "common/buttons"
import EntitlementPageGuard from "components/Subscription/EntitlementPageGuard"
import { DYNAMIC_ELEMENTS } from "constants/entitlements"
import {
  FROM_BANK,
  useDynamicElements,
} from "hooks/DynamicElements/useDynamicElements"

const DynamicElementsIndex = () => {
  const {
    dynamicElements,
    dispatches,
    isHowToAddModalOpen,
    dynamicElementsConfig,
  } = useDynamicElements()

  const { user } = useContext(AuthContext)
  const organizationId = user?.["custom:organizationId"] || null

  useEffect(() => {
    if (dynamicElementsConfig.showBankPriceInitialModal) {
      dispatches.setIsHowToAddModalOpen(true)
    }
    return () => {
      // Esta función se ejecuta al desmontar el componente
      dispatches.setDynamicElementsToInitialState()
    }
  }, [])

  const handleOnUpdate = () => {
    dispatches.getDynamicElementsConvertFrom(organizationId, FROM_BANK)
  }

  return (
    <EntitlementPageGuard permission={DYNAMIC_ELEMENTS}>
      <Box sx={{ px: 2 }}>
        {organizationId && (
          <>
            <Typography variant="h6" component="h1" sx={{ mb: 3 }}>
              Elementos dinámicos
            </Typography>
            <DynamicElementList
              className={"mb-3"}
              organizationId={organizationId}
            >
              {dynamicElements && (
                <>
                  <Box
                    sx={{
                      width: "100%",
                      padding: 4,
                      borderRadius: 2,
                      border: "1px solid #E5E5E5",
                      boxShadow: "0px 0px 9px rgba(0, 0, 0, 0.1)",
                      backgroundColor: "white",
                    }}
                  >
                    <DynamicElementForm poolId={organizationId} />
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      marginBottom: 1,
                      marginTop: 2,
                    }}
                  >
                    <Button
                      variant="outlined"
                      sx={greyButtonStyle}
                      onClick={handleOnUpdate}
                    >
                      {i18n.t("buttons.update")}
                    </Button>
                  </Box>
                </>
              )}
            </DynamicElementList>

            {dynamicElementsConfig.showBankPriceInitialModal && (
              <HowToAddDynamicElementsModal
                open={isHowToAddModalOpen}
                onClose={isOpen => {
                  dispatches.setIsHowToAddModalOpen(isOpen)
                  dispatches.setDynamicElementsConfig({
                    ...dynamicElementsConfig,
                    showBankPriceInitialModal: false,
                  })
                }}
                onUpdate={handleOnUpdate}
              />
            )}
          </>
        )}
      </Box>
    </EntitlementPageGuard>
  )
}

export default DynamicElementsIndex
